import {
  pnlBreakdownDataAtom,
  pnlBreakdownsByProcessAtom,
  pnlBreakdownsByShiftAtom,
  pnlBreakdownsBySKUAtom,
  pnlBreakdownByShiftAndProcessAtom,
} from "./store";
import { useAtom } from "jotai";

export default function useEosData() {
  const [data] = useAtom(pnlBreakdownDataAtom);
  const [pnlBreakdownsByProcess] = useAtom(pnlBreakdownsByProcessAtom);
  const [pnlBreakdownsBySKU] = useAtom(pnlBreakdownsBySKUAtom);
  const [pnlBreakdownsByShift] = useAtom(pnlBreakdownsByShiftAtom);
  const [pnlBreakdownByShiftAndProcess] = useAtom(
    pnlBreakdownByShiftAndProcessAtom
  );
  return {
    data,
    pnlBreakdownsByProcess,
    pnlBreakdownsBySKU,
    pnlBreakdownsByShift,
    pnlBreakdownByShiftAndProcess,
  };
}
